import Vue from '../../lib/vue2.js';
import Datepicker from 'vuejs-datepicker';
import axios from 'axios';
import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';
import JQuery from 'jquery'
import multiformHelper from './helper'


Vue.component('generalForm', {
    template: '#generalForm',
    components: {
        'vue-datepicker': Datepicker
    },
    watch: {
    },
    data: function () {
        return {
            errors: [],
            formErrorMsg: false,
            formSuccessMsg: false,
            formData: {
                first_name: '',
                last_name: '',
                email: '',
                msg: '',
                grecaptcha: ''
            },
            formError: {
                first_name: false,
                last_name: false,
                email: false,
                msg: false,
                grecaptcha: false
            },
        };
    },
    mounted: function() {

    },
    created: function () {
        console.log('created generalForm component');
    },
    methods: {
        submit: function() {
            var component = this;

            console.log("submited generalForm", this.formData);

            // remove messages
            this.formSuccessMsg = false;
            this.formErrorMsg = false;

            
            multiformHelper.submitWithRecaptcha3('/' + window.langCode + '/xgeneral', this.formData, (validationObj) => {

                console.log('SUBMITTED', validationObj);

                this.formError = validationObj.formError;

                if(validationObj.formErrorMsg)
                {
                    this.formErrorMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--e.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formErrorMsg = false;
                    }, 10000);
                }
                else if(validationObj.formSuccessMsg)
                {

                    this.formSuccessMsg = true;
                    setTimeout(() => {
                        let el = document.querySelector('.close-btn.close-btn--s.js-fstatus');
                        el.classList.add('is-active');
                    }, 0);

                    setTimeout(()=>{
                        this.formSuccessMsg = false;
                    }, 10000);

                    // clear form by ref
                    this.$refs.generalForm.reset(); 

                    for ( var key in this.formData ) 
                    {
                        if(key!=='type')
                        {
                            this.formData[key] = '';
                        } 
                    }
                }

            });

        },
        myFilter: function() {
            console.log("kilk"); 
        }
    }
});


